<template>
    <v-form ref="form">
        <v-card>
            <v-card-title>
                <span class="headline">{{ $vuetify.lang.t('$vuetify.custom.exam.examAdd') }}</span>
            </v-card-title>
            <v-card-text>
                <v-container>
                    <v-row class="mt-6">
                        <v-col cols="12">
                            <v-select
                                :items="classItems"
                                :label="$vuetify.lang.t('$vuetify.custom.exam.className')"
                                hide-details
                                solo
                                v-model="formData.classId"
                            ></v-select>
                        </v-col>
                        <v-col cols="12">
                            <v-text-field
                                :label="$vuetify.lang.t('$vuetify.custom.exam.examName')"
                                v-model="formData.examName"
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-menu
                                ref="menu"
                                v-model="menu"
                                :close-on-content-click="false"
                                :return-value.sync="formData.examTime"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                    <v-text-field
                                        v-model="formData.examTime"
                                        label="考试时间"
                                        readonly
                                        v-bind="attrs"
                                        v-on="on"
                                    ></v-text-field>
                                </template>
                                <v-date-picker v-model="formData.examTime" locale="zh-cn" no-title scrollable>
                                    <v-spacer></v-spacer>
                                    <v-btn text color="primary" @click="menu = false">取消</v-btn>
                                    <v-btn text color="primary" @click="$refs.menu.save(formData.examTime)">确定</v-btn>
                                </v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col cols="12">
                            <v-select
                                :items="typeItems"
                                :label="$vuetify.lang.t('$vuetify.custom.exam.type')"
                                hide-details
                                solo
                                v-model="formData.type"
                            ></v-select>
                        </v-col>
                        <v-col cols="12">
                            <v-select
                                :items="examTypeItems"
                                :label="$vuetify.lang.t('$vuetify.custom.exam.examType')"
                                hide-details
                                solo
                                v-model="formData.examType"
                            ></v-select>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="error" dark @click="hiddenDialog">{{ $vuetify.lang.t('$vuetify.custom.cancelBtn') }}
                </v-btn>
                <v-btn color="success" dark @click="addExam">{{ $vuetify.lang.t('$vuetify.custom.addBtn') }}</v-btn>
            </v-card-actions>
        </v-card>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-form>
</template>
<style></style>
<script>
    export default {
        name: 'user-add',
        model: {
            prop: 'dialog',
            event: 'parent-event'
        },
        props: {
            dialog: Boolean
        },
        mounted() {
            this.initClassItems()
        },
        data: () => ({
            overlay: false,
            menu: false,
            formData: {
                className: '',
                examName: '',
                examTime: new Date().toISOString().substr(0, 10),
                type: '',
                examType: ''
            },
            rules: {
                required: value => !!value || '请输入'
            },
            classItems: [],
            typeItems: [
                {text: '月考', value: '1'},
                {text: '周考', value: '0'},
            ],
            examTypeItems: [
                {text: '笔试', value: '1'},
                {text: '面试', value: '0'},
            ],
        }),
        watch: {
            dialog() {
                if (this.dialog) {
                    this.formData.examTime = new Date().toISOString().substr(0, 10)
                }
            }
        },
        methods: {
            initClassItems() {
                this.$api.classList.getAllClass({
                    params: {
                        type: '0'
                    }
                }).then(data => {
                    if (data.data) {
                        data.data.forEach(obj => {
                            this.classItems.push({text: obj.className, value: obj.id})
                        })
                    }
                })
            },
            hiddenDialog() {
                this.$emit('parent-event', false);
                this.$refs.form.reset()
            },
            addExam() {
                this.overlay = true
                if (this.$refs.form.validate()) {
                    this.$api.exam.addExam(this.formData).then(data => {
                        this.overlay = false
                        if (data.flag) {
                            this.$dialog.alert(this.$vuetify.lang.t('$vuetify.custom.addSuccess'));
                            this.$emit('initialize')
                            this.hiddenDialog();
                        } else {
                            this.$dialog.alert(data.msg)
                            this.$refs.form.reset()
                        }
                    })

                }
            }
        },
    }
</script>
